import UserDetailStatisticReducer from './UserDetailStatisticReducer';

export default from './UserDetailStatisticContainer';
export const UserDetailStatisticReducers = {
  UserDetailStatisticReducer,
};
